import React, { useMemo } from 'react';
import { ClockIcon } from 'cokitchen-icons';
import moment from 'moment';
import { IssueType } from 'models/issue.model';

const UserIssueCard = ({ item }: { item: Partial<IssueType> }) => {
  const firstTextToUpper = useMemo(() => {
    if (item.feedback_summary) {
      const text = item.feedback_summary.charAt(0).toUpperCase() + item.feedback_summary.slice(1);

      return text;
    }
  }, [item]);

  return (
    <div className='border py-3 border-[#E4E6E7] text-xs rounded-lg min-w-[360px]'>
      <p className='px-4 text-gray-6 pb-3 text-left'>{firstTextToUpper}</p>
      <hr className='text-[#E4E6E7] pt-3' />
      <div className='flex text-gray-5 px-4 items-center gap-2'>
        <ClockIcon />
        <p>{moment(item.created_at).format('MMM DD, YYYY')}</p>
      </div>
    </div>
  );
};

export default UserIssueCard;
